<template>
  <div>
    <el-button
      size="mini"
      type="primary"
      @click="downloadClick()"
      icon="el-icon-download"
      class="btn"
    >下载</el-button>
    <div class="box">
      <div id="wecode" v-show="false"></div>
      <canvas id="canvas" style="display:none"></canvas>
    </div>
    <a id="downloadLink"></a>
    <img
      v-show="false"
      ref="backImg"
      src="@/assets/images/background.jpg"
      alt
      style="border:1px solid gray;"
    />
    <canvas ref="myCanvas" width="500" height="500"></canvas>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { baseurl } from "../../../base.js";
export default {
  components: {
    QRCode: QRCode
  },
  created() {
    this.pid = localStorage.getItem("pid");
    this.orgMerId = localStorage.getItem("orgMerId");
    this.name = localStorage.getItem("userName");
    this.baseurl = `${baseurl}/m/h5restaurant?merId=${localStorage.getItem(
      "merId"
    )}&platCode=${localStorage.getItem("platCode")}`;
    // this.baseurl = `https://yyg.chinanums.com/api/m/h5restaurant?merId=${localStorage.getItem(
    //   "merId"
    // )}&platCode=${localStorage.getItem("platCode")}`;
  },
  mounted() {
    this.useqrcode();
  },
  data() {
    return {
      pid: "",
      orgMerId: "",
      baseurl: "",
      name: ""
    };
  },
  methods: {
    useqrcode() {
      let data = this.baseurl.trim();
      var canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, data, error => {
        if (error) console.error(error);
        console.log("success!");
        this.imgcreate();
      });
    },
    imgcreate() {
      function convertCanvasToImage(canvas) {
        //新Image对象，可以理解为DOM
        var image = new Image(); // canvas.toDataURL 返回的是一串Base64编码的URL，当然,浏览器自己肯定支持 // 指定格式PNG
        image.src = canvas.toDataURL("image/png");
        return image;
      } //获取网页中的canvas对象
      let ctx = this.$refs.myCanvas.getContext("2d");
      ctx.rect(0, 0, 500, 500);
      ctx.stroke();
      let backImg = new Image();
      backImg.src = require("@/assets/images/background.jpg");
      backImg.onload = function() {
        ctx.drawImage(backImg, 0, 0, 500, 500);
        var mycanvas1 = document.getElementById("canvas"); //将转换后的img标签插入到html中
        var img = convertCanvasToImage(mycanvas1);
        img.onload = function() {
          ctx.drawImage(img, 150, 190, 200, 200);
        };
      };
    },
    downloadClick() {
      if (navigator.msSaveBlob) {
        let blob = this.$refs.myCanvas.msToBlob();
        window.navigator.msSaveBlob(blob, "二维码.png");
      } else {
        var url = this.$refs.myCanvas.toDataURL("image/png");
        var downloadLink = document.getElementById("downloadLink");
        downloadLink.setAttribute("href", url);
        downloadLink.setAttribute("download", "二维码.png");
        downloadLink.click();
      }
    }
  }
};
</script>

<style scoped>
.btn {
  margin: 15px;
}
.box {
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/view/page/qrcode/qrcode.vue